import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { ActionUpdaterService, ApiError } from './../../../shared/services/action-updater.service';
import { Booking, PaymentItem, Totals, Package, Pass } from '../../../shared/models/booking.model';
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { debounce } from 'rxjs/operator/debounce';
import { BookingTotalKms } from 'app/shared/models/booking-total.model';
import { ProductTypeUrl } from 'app/shared/models/enums/ProductTypeUrl.enum';
import { TravelProductService } from 'app/shared/services/travel-product.service';

@Component({
    selector: 'gaweb-booking-total',
    templateUrl: './booking-total.component.html',
    styleUrls: ['./booking-total.component.less']
})
export class BookingTotalComponent implements OnInit, OnChanges {
    @Input() bookingGuid: string;
    @Input() loadingBookings: boolean;

    @Input() bookingTotal: BookingTotalKms;
    @Input() freeTripClaimed: boolean;

    @Output() onTotalsUpdating: EventEmitter<Totals> = new EventEmitter();
    @Output() onRemovePromo: EventEmitter<any> = new EventEmitter();
    @Input()
    productType: ProductTypeUrl;
    private _totals: Totals;
    @Input()
    set totals(t: Totals) {
        this._totals = t;
    }
    get totals(): Totals {
        return this._totals;
    }
    @Input() loadingCartTotal: boolean;
    @Input() addonMode: boolean;
    isBookingVerified: boolean;
    @Input() packageName: string;
    hasPromo: boolean;
    promoDescription: string | null;
    promoAmount: number | null;
    originalAmount: number | null;
    canCancelPromo: boolean = true;

    constructor(private travelPackageService: TravelProductService,
        private actionUpdaterService: ActionUpdaterService) { }

    ngOnInit() {
        //this.canCancelPromo = true;
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['bookingGuid'] &&
            this.productType !== ProductTypeUrl.travelPasses && this.productType !== ProductTypeUrl.expressBooking) {
            this.updateCartTotal();
        }
        if (!changes['bookingTotal'] || changes['bookingTotal'].isFirstChange()) {
            return;
        }
        const bookingtotal: BookingTotalKms = changes['bookingTotal'].currentValue;
        this.isBookingVerified = bookingtotal.isBookingVerified;
        if (this.isBookingVerified) {
            this.totals = new Totals();
            this.totals.TotalCost = bookingtotal.balanceAfterPayment;

            const balanceBeforePaymentItem = new PaymentItem();
            balanceBeforePaymentItem.Description = 'Balance Before Payment';
            balanceBeforePaymentItem.Total = bookingtotal.balanceBeforePayment;

            const farePriceKMSItem = new PaymentItem();
            farePriceKMSItem.Description = 'Fare Price';
            farePriceKMSItem.Total = bookingtotal.farePriceKMS;

            this.totals.PaymentItems = [
                balanceBeforePaymentItem,
                farePriceKMSItem
            ];
        } else if (!changes['bookingGuid'] && bookingtotal.isLogout) {
            this.updateCartTotal();
        }
    }

    removePromoCode = () => {
        this.onRemovePromo.emit();
    }

    public updateCartTotal = () => {
        if (!this.isBookingVerified && !!this.bookingGuid) {
            this.loadingCartTotal = true;
                    this.travelPackageService.getCartTotal(this.bookingGuid)
                    .subscribe((totals: Totals) => {
                        this.totals = totals;
                        this.onTotalsUpdating.emit(totals)
                        if(this.hasPromo){
                            this.promoAmount = 0;
                            if(!!this.totals && !!this.originalAmount && this.totals.PaymentItems){
                                if(this.totals.PaymentItems[0].Total > 0){
                                    this.promoAmount = this.originalAmount - this.totals.PaymentItems[0].Total;
                                } else {
                                    this.promoAmount = this.originalAmount - this.totals.PaymentItems[1].Total;
                                }
                            }
                        }
                        this.loadingCartTotal = false;
                    }, this.actionUpdaterService.onError);
        }
    }

    public setPromo = (hasPromo: boolean, desc: string, origAmount: number, hideRemove: boolean = false) => {
        this.hasPromo = hasPromo;
        this.promoDescription = desc;
        this.originalAmount = origAmount;
        this.canCancelPromo = !hideRemove;
        this.promoAmount = 0;
        if(!!this.totals && !!this.totals.PaymentItems)
        {
            if(this.totals.PaymentItems[0].Total > 0){
                this.promoAmount = this.originalAmount - this.totals.PaymentItems[0].Total;
            } else {
                this.promoAmount = this.originalAmount - this.totals.PaymentItems[1].Total;
            }
        }
    }

    public updatePromoStatus = (originalAmount: number, $event: string) => {
        if(!!$event){
            this.hasPromo = true;
            this.promoDescription = $event;
            this.originalAmount = originalAmount;
        } else {
            this.hasPromo = false;
            this.promoDescription = null;
            this.promoAmount = null;
            this.originalAmount = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/travel-products/product-passenger-details/booking-total/booking-total.component.ts